import { FormsProvider } from "../../context/forms/FormsContextProvider";

import MainPage from "./components/MainPage";

function Forms() {
  return (
    <FormsProvider>
      <MainPage />
    </FormsProvider>
  );
}

export default Forms;
